/** Statsig dynamic config that holds the Ops-curated cohort. */
export const AI_ANSWERS_COHORT_CONFIG = "ai_instant_responses_cohort_listings";

/** Key inside the dynamic config whose value is the array of activated listing IDs. */
export const AI_ANSWERS_COHORT_LISTING_IDS_KEY = "listing_ids";

/** Statsig A/B experiment that splits the cohort into control and test arms. */
export const AI_ANSWERS_EXPERIMENT = "ai_instant_responses";

/** Boolean parameter on the experiment; true only for the test arm. */
export const AI_ANSWERS_SHOW_MODAL_KEY = "show_ai_instant_answers_modal";

/** Opening topic pills are capped at one per category, up to this many. */
export const MAX_TOPIC_PILLS = 10;

/**
 * Soft cap on a single question, matching the BE `:text` schema (max 2000). The guest
 * can type past it, but the send button is disabled and an over-count warning shows
 * until they trim back to the limit.
 */
export const MAX_MESSAGE_LENGTH = 2000;

export const MIN_TEXTAREA_HEIGHT = 24; // 1 row

export const MAX_TEXTAREA_HEIGHT = 96; // 4 rows

/** Timestamp format for message meta lines (e.g. "2:20 PM"), matching the chat design. */
export const MESSAGE_TIME_FORMAT = "h:mm a";

/** Milliseconds of stagger between consecutive words in the assistant reply reveal. */
export const WORD_ANIMATION_DELAY_STEP_MS = 18;

/** Milliseconds each word takes to fade in (opacity 0 → 1, linear). */
export const WORD_ANIMATION_FADE_DURATION_MS = 120;

/**
 * Ceiling on a single word's stagger delay. Past this every remaining word starts
 * fading together, so a long reply still finishes quickly instead of dragging on.
 */
export const WORD_ANIMATION_MAX_DELAY_MS = 1080; // 60 words * WORD_ANIMATION_DELAY_STEP_MS

/** How long each rotating "thinking" phrase shows before advancing, in ms. */
export const THINKING_PHRASE_INTERVAL_MS = 2000;

/** Stacks popups opened from the chat (date picker, time select) above the modal's z-[10001]. */
export const CHAT_POPUP_Z_INDEX_CLASS = "!tw-z-[10002]";

/** Quiet period after the last schedule change before the availability check is sent. */
export const AVAILABILITY_CHECK_DEBOUNCE_MS = 500;
